<nav class="navbar navbar-expand-lg" [ngClass]="{ 'fixed-top': isMobile, 'is-green': isGreenStyle, 'is-purple': isPurpleHeader }">
  <div class="navbar-mobile">
    <a *ngIf="isPayment" class="navbar-link-back-white" (click)="goBack()">
      <img src="/assets/icons/icon_arrow_md_white.svg" />
    </a>

    <a *ngIf="isAccountSettings" class="navbar-link-back" (click)="openSettingsMenu()">
      <img class="back" src="/assets/icons/icon_right.svg" />
    </a>

    <a class="navbar-brand" [routerLink]="['/']" *ngIf="!isPayment">
      <img
        class="logo-img"
        [src]="isGreenStyle ? '/assets/images/eezyimport-logo-m.svg' : '/assets/images/eezyimport-logo-torquse-m.svg'"
        alt="logo"
      />
    </a>

    <div class="content-header" *ngIf="mobileTitle && mobileTitle.length">
      <span *ngFor="let segment of mobileTitle; let last = last; let first = first">
        <a
          *ngIf="segment.link"
          class="segment-link"
          [routerLink]="'/' + (segment.link | translate : segment.params)"
          [queryParams]="queryParams"
        >
          {{ last || first ? (segment.key | translate : segment.params) : "..." }}
        </a>
        <span *ngIf="!segment.link" class="segment-link">
          {{ last || first ? (segment.key | translate : segment.params) : "..." }}
        </span>
        <span class="slash" *ngIf="!last">/</span>
      </span>
    </div>
  </div>
  <app-header-actions-mobile></app-header-actions-mobile>
  <div class="d-flex align-items-center">
    <div *ngIf="isShowInternalNotes">
      <ng-container *ngTemplateOutlet="internalNotes"></ng-container>
    </div>
    <div class="collapse navbar-collapse">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown" dropdown container="body">
          <a href="javascript:void(0)" class="nav-link" dropdownToggle>
            <i class="fa fa-user"></i>
            &nbsp;{{ user.email }}
            <b class="caret"></b>
          </a>
          <div class="dropdown-menu dropdown-menu-right" *dropdownMenu>
            <a class="dropdown-item" href="javascript:void(0)" (click)="goToCompany()">
              {{ (companies.length > 1 ? "LABELS.IMPORTERS_OF_RECORD" : "LABELS.IMPORTER_OF_RECORD") | translate }}
            </a>
            <a class="dropdown-item" [routerLink]="['/legal-terms']">{{ "MENU.LEGAL_TERMS" | translate }}</a>
            <a class="dropdown-item" [routerLink]="['/privacy-policy']">{{ "PAGE.POLICY.PRIVACY_POLICY" | translate }}</a>
            <a class="dropdown-item" [routerLink]="['/login']" (click)="logout($event)">{{ "MENU.LOG_OUT" | translate }}</a>
          </div>
        </li>
      </ul>
    </div>
    <button class="navbar-toggler" type="button" (click)="toggleSidebar()">
      <i class="fa fa-bars"></i>
    </button>
  </div>
</nav>

<ng-template #internalNotes>
  <div class="internal-notes-container" (click)="openInternalNotes()">
    <img [src]="!!internalNote.internalNotes ? 'assets/icons/icon_edit_notes_white.svg' : 'assets/icons/icon_add_notes_white.svg'" />
    <span
      nz-tooltip
      nzTooltipColor="#ffffff"
      nzTooltipOverlayClassName="tooltip-sm"
      nzTooltipPlacement="bottom"
      [nzTooltipTitle]="(!!internalNote.internalNotes ? 'LABELS.INTERNAL_NOTES_EDIT_HINT' : 'LABELS.INTERNAL_NOTES_ADD_HINT') | translate"
    ></span>
  </div>
</ng-template>
